import { SchemaType } from '../type';
export const schema = {
    id: 'ai_project_info',
    name: 'AI页面信息',
    type: SchemaType.Indivisible,
};
